import React from "react";
import { ApplicationSubPages } from "./ApplicationMenu";
import { useSubPages } from "../../shared/components/page/SubPageProvider";
import { Application } from "./Application";
import { ApplicationInformationSubPage } from "./ApplicationInformationSubPage";
import { ApplicationTranslationsSubPage } from "./ApplicationTranslationsSubPage";
import { ApplicationRolesSubPage } from "./ApplicationRolesSubPage";
import { ApplicationUserGroupsSubPage } from "./groups/ApplicationUserGroupsSubPage";
import { LicensesSubPage } from "./licenses/LicensesSubPage";
import { useAccount } from "../users/AccountProvider";
import { mayEditApplication } from "./permissions";
import { TermsAndConditionsSubPage } from "./terms-and-conditions/TermsAndConditionsSubPage";

export function ApplicationContent(props: {
  application: Application,
  handleSave: (application: Application) => Promise<Application>,
  handleDelete: (application: Application) => void,
}) {
  const { application } = props;
  const { selectedSubPage } = useSubPages();
  const account = useAccount();

  return <>
    {selectedSubPage === ApplicationSubPages.INFORMATION &&
      <ApplicationInformationSubPage application={props.application} handleSave={props.handleSave} handleDelete={props.handleDelete} />
    }
    {selectedSubPage === ApplicationSubPages.TRANSLATIONS && mayEditApplication(account, application) &&
      <ApplicationTranslationsSubPage application={props.application} handleSave={props.handleSave} />
    }
    {selectedSubPage === ApplicationSubPages.TERMS_AND_CONDITIONS && mayEditApplication(account, application) &&
      <TermsAndConditionsSubPage application={props.application} />
    }
    {selectedSubPage === ApplicationSubPages.ROLES && mayEditApplication(account, application) &&
      <ApplicationRolesSubPage application={props.application} handleSave={props.handleSave} />
    }
    {selectedSubPage === ApplicationSubPages.LICENSES && mayEditApplication(account, application) &&
      <LicensesSubPage application={props.application} />
    }
    {selectedSubPage === ApplicationSubPages.GROUPS && mayEditApplication(account, application) &&
      <ApplicationUserGroupsSubPage application={props.application} />
    }
  </>
}
